(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["battery-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fmtHours(h) {
    if (h >= 10) return Math.round(h) + ' hours';
    return (Math.round(h * 10) / 10) + ' hours';
  }

  function analyse(state, packs, cfg) {
    var chMult = cfg.chMult[String(state.ch)] || 1;
    var resMult = cfg.resMult[String(state.res)] || 1;
    var park = Number(state.park);
    var drive = Number(state.drive);

    return packs.map(function (p) {
      // Measured figures beat estimates: if the manufacturer publishes a real
      // multi-channel runtime, use it instead of applying our multiplier.
      var base = p.hours * chMult;
      var measured = false;
      if (String(state.ch) === '2' && p.hours2) { base = p.hours2; measured = true; }
      if (String(state.ch) === '3' && p.hours3) { base = p.hours3; measured = true; }
      var adj = base * resMult;
      var rechargeFull = p.recharge && p.recharge > 0 ? p.recharge : Math.round(p.mah / 100);
      var usedFrac = Math.min(park / adj, 1);
      var needMin = usedFrac * rechargeFull;
      return Object.assign({}, p, {
        adj: adj,
        measured: measured,
        needMin: needMin,
        meets: adj >= park,
        keepsUp: drive >= needMin * 0.9
      });
    });
  }

  function choose(rows, cfg) {
    var usable = rows.filter(function (r) { return r.available; });
    var pool = usable.filter(function (r) { return r.meets && r.keepsUp; });
    var relaxed = false;

    if (!pool.length) {
      pool = usable.filter(function (r) { return r.meets; });
      relaxed = true;
    }
    if (!pool.length) {
      // nothing covers the full window — take the longest runtime available
      pool = usable.slice().sort(function (a, b) { return b.adj - a.adj; }).slice(0, 1);
      return { primary: pool[0] || null, alts: [], shortfall: true, relaxed: relaxed };
    }

    pool.sort(function (a, b) { return a.priceCents - b.priceCents; });
    var primary = pool[0];

    // House-brand tiebreak: prefer a flagged pack when it costs no more than 12% above the cheapest fit.
    var preferred = pool.filter(function (r) { return r.preferred; })[0];
    if (preferred && preferred !== primary && preferred.priceCents <= primary.priceCents * 1.12) {
      primary = preferred;
    }

    var alts = pool.filter(function (r) { return r !== primary; }).slice(0, 2);
    return { primary: primary, alts: alts, shortfall: false, relaxed: relaxed };
  }

  function chooseCombo(rows, park, drive) {
    // Only reached when no single pack covers the window. Finds the cheapest
    // base-plus-expansion combination that does.
    var best = null;
    rows.forEach(function (r) {
      if (!r.available || !r.expVariantId) return;
      var max = r.expMax || 1;
      var ratio = (r.expRatio || 100) / 100;
      for (var n = 1; n <= max; n++) {
        var adj = r.adj * (1 + n * ratio);
        if (adj < park) continue;
        var rechargeFull = (r.recharge && r.recharge > 0 ? r.recharge : Math.round(r.mah / 100)) * (1 + n * ratio);
        var needMin = Math.min(park / adj, 1) * rechargeFull;
        var cand = {
          base: r,
          count: n,
          adj: adj,
          priceLabel: (r.comboPrices && r.comboPrices[n - 1]) || '',
          totalCents: r.priceCents + (r.expPriceCents || 0) * n,
          keepsUp: drive >= needMin * 0.9
        };
        // the smallest n that works is always the cheapest for this pack
        if (!best || r.priceCents < best.base.priceCents) best = cand;
        break;
      }
    });
    return best;
  }

  function render(root, state, packs, cfg) {
    var box = root.querySelector('[data-ldsc-result]');
    var prompt = root.querySelector('[data-ldsc-prompt]');
    var rows = analyse(state, packs, cfg);
    var park = Number(state.park);
    var html = '';

    var hardwire = park <= cfg.hardwireHours && String(state.ch) === '1';

    if (hardwire) {
      html += '<div class="ldsc-result__head">';
      html += '<p class="ldsc-result__verdict">' + esc(cfg.hardwireTitle) + '</p>';
      if (cfg.hardwireBody) html += '<p class="ldsc-result__why">' + esc(cfg.hardwireBody) + '</p>';
      html += '</div><div class="ldsc-result__body">';
      if (cfg.hardwireUrl) {
        html += '<a class="ldsc-btn" href="' + esc(cfg.hardwireUrl) + '">' + esc(cfg.hardwireLabel) + '</a>';
      }
    }

    var pick = choose(rows, cfg);
    var p = pick.primary;
    var combo = pick.shortfall && !hardwire ? chooseCombo(rows, park, Number(state.drive)) : null;

    if (combo) {
      html += '<div class="ldsc-result__head">';
      html += '<p class="ldsc-result__verdict">' + esc(cfg.comboTitle) + '</p>';
      if (cfg.comboBody) html += '<p class="ldsc-result__why">' + esc(cfg.comboBody) + '</p>';
      html += '</div><div class="ldsc-result__body">';
      html += '<div class="ldsc-pick">';
      if (combo.base.image) html += '<img class="ldsc-pick__img" src="' + esc(combo.base.image) + '" alt="" loading="lazy">';
      html += '<div><p class="ldsc-pick__name"><a href="' + esc(combo.base.url) + '">' + esc(combo.base.title) + '</a>' +
              ' + ' + esc(combo.count > 1 ? combo.count + ' x ' : '') +
              '<a href="' + esc(combo.base.expUrl) + '">' + esc(combo.base.expTitle) + '</a></p>';
      html += '<p class="ldsc-pick__runtime">about ' + esc(fmtHours(combo.adj)) + ' in your setup</p>';
      html += '<p class="ldsc-pick__meta">' + esc(combo.priceLabel) + ' together &middot; ' +
              esc(combo.base.price) + ' + ' + esc(combo.base.expPrice) + '</p>';
      html += '<div class="ldsc-pick__actions">';
      html += '<button type="button" class="ldsc-btn" data-ldsc-add data-variant="' + esc(combo.base.variantId) +
              '" data-exp-variant="' + esc(combo.base.expVariantId) + '" data-exp-qty="' + esc(combo.count) +
              '" data-title="' + esc(combo.base.title) + '">' + esc(cfg.comboButton) + '</button>';
      if (cfg.installOk) {
        html += '<label class="ldsc-check"><input type="checkbox" data-ldsc-install> ' + esc(cfg.installLabel) + ' (' + esc(cfg.installPrice) + ')</label>';
      }
      html += '</div><p class="ldsc-err" data-ldsc-err hidden></p></div></div>';
      if (!combo.keepsUp && cfg.rechargeWarning) {
        html += '<div class="ldsc-note">' + esc(cfg.rechargeWarning) + '</div>';
      }
      html += '</div>';
      box.innerHTML = html;
      box.hidden = false;
      if (prompt) prompt.hidden = true;
      return;
    }

    if (!hardwire) {
      html += '<div class="ldsc-result__head">';
      if (pick.shortfall) {
        html += '<p class="ldsc-result__verdict">' + esc(cfg.shortfallTitle) + '</p>';
        if (cfg.shortfallBody) html += '<p class="ldsc-result__why">' + esc(cfg.shortfallBody) + '</p>';
      } else {
        var chLabel = state.ch === '1' ? '1 channel' : (state.ch === '3' ? '3+ channels' : state.ch + ' channels');
        var durLabel = park >= 48 ? 'a weekend or more' : park >= 24 ? 'a full day' : park >= 12 ? 'overnight' : 'a few hours';
        html += '<p class="ldsc-result__verdict">' + esc(cfg.needTitle) + '</p>';
        var needBody = (cfg.needBody || '').replace(/\[channels\]/g, chLabel).replace(/\[duration\]/g, durLabel);
        if (needBody) html += '<p class="ldsc-result__why">' + esc(needBody) + '</p>';
      }
      html += '</div><div class="ldsc-result__body">';
    }

    if (p) {
      if (hardwire) html += '<p class="ldsc-alts__label" style="margin-top:20px">If you would rather not cycle your starter battery at all</p>';
      html += '<div class="ldsc-pick">';
      if (p.image) html += '<img class="ldsc-pick__img" src="' + esc(p.image) + '" alt="" loading="lazy">';
      html += '<div><p class="ldsc-pick__name"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></p>';
      html += '<p class="ldsc-pick__runtime">about ' + esc(fmtHours(p.adj)) + ' in your setup</p>';
      html += '<p class="ldsc-pick__meta">' + esc(p.mah) + 'mAh';
      if (p.wh) html += ' (' + esc(p.wh) + 'Wh)';
      html += ' &middot; ' + esc(p.price);
      if (p.measured) html += ' &middot; manufacturer-tested at this channel count';
      if (p.note) html += ' &middot; ' + esc(p.note);
      html += '</p>';
      html += '<div class="ldsc-pick__actions">';
      html += '<button type="button" class="ldsc-btn" data-ldsc-add data-variant="' + esc(p.variantId) + '" data-title="' + esc(p.title) + '">' + esc(cfg.buyLabel) + '</button>';
      if (cfg.installOk) {
        html += '<label class="ldsc-check"><input type="checkbox" data-ldsc-install> ' + esc(cfg.installLabel) + ' (' + esc(cfg.installPrice) + ')</label>';
      }
      html += '</div><p class="ldsc-err" data-ldsc-err hidden></p></div></div>';

      if (!pick.shortfall && pick.relaxed && cfg.rechargeWarning) {
        html += '<div class="ldsc-note">' + esc(cfg.rechargeWarning) + '</div>';
      }

      if (pick.alts.length) {
        html += '<div class="ldsc-alts"><p class="ldsc-alts__label">Also fits</p>';
        pick.alts.forEach(function (a) {
          html += '<div class="ldsc-alt"><a href="' + esc(a.url) + '">' + esc(a.title) + '</a>' +
                  '<span>' + esc(fmtHours(a.adj)) + ' &middot; ' + esc(a.price) + '</span></div>';
        });
        html += '</div>';
      }
    }

    html += '</div>';
    box.innerHTML = html;
    box.hidden = false;
    if (prompt) prompt.hidden = true;
  }

  function addToCart(root, button, cfg) {
    var items = [{ id: Number(button.dataset.variant), quantity: 1 }];
    if (button.dataset.expVariant) {
      items.push({ id: Number(button.dataset.expVariant), quantity: Number(button.dataset.expQty || 1) });
    }
    var installBox = root.querySelector('[data-ldsc-install]');
    if (installBox && installBox.checked && cfg.installOk) {
      items.push({ id: Number(cfg.installVariantId), quantity: 1, properties: { 'Installation for': button.dataset.title } });
    }
    var errEl = root.querySelector('[data-ldsc-err]');
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (d) {
          if (!res.ok) throw new Error(d.description || d.message || 'That could not be added.');
          return d;
        });
      })
      .then(function () {
        if (cfg.afterAdd === 'checkout') window.location.href = '/checkout';
        else if (cfg.afterAdd === 'stay') {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = 'Added to cart';
        } else window.location.href = '/cart';
      })
      .catch(function (e) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (errEl) { errEl.textContent = e.message || 'Something went wrong. Please try again.'; errEl.hidden = false; }
      });
  }

  function init(root) {
    if (root.dataset.ldscReady === 'true') return;
    root.dataset.ldscReady = 'true';

    var packs, cfg;
    try {
      packs = JSON.parse(root.querySelector('[data-ldsc-packs]').textContent);
      cfg = JSON.parse(root.querySelector('[data-ldsc-config]').textContent);
    } catch (e) { return; }

    var state = {};

    root.addEventListener('click', function (event) {
      var opt = event.target.closest('.ldsc-opt');
      if (opt) {
        var key = opt.dataset.key;
        state[key] = opt.dataset.value;
        root.querySelectorAll('.ldsc-opt[data-key="' + key + '"]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === opt ? 'true' : 'false');
        });
        if (state.ch && state.res && state.park && state.drive) render(root, state, packs, cfg);
        return;
      }
      var add = event.target.closest('[data-ldsc-add]');
      if (add && !add.disabled) addToCart(root, add, cfg);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ldsc-calc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-install-toggle-backup-pre-override"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STORE_KEY = 'lds-install-mode';

  function readStored() {
    try { return window.localStorage.getItem(STORE_KEY); } catch (e) { return null; }
  }

  function writeStored(mode) {
    try { window.localStorage.setItem(STORE_KEY, mode); } catch (e) { /* private mode */ }
  }

  function setMode(root, mode, persist) {
    root.classList.toggle('is-inst', mode === 'inst');
    root.classList.toggle('is-ship', mode !== 'inst');
    root.querySelectorAll('.lds-switch__btn[data-lds-mode]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.dataset.ldsMode === mode ? 'true' : 'false');
    });
    if (persist && root.dataset.remember === 'true') writeStored(mode);
  }

  function showError(root, message) {
    var el = root.querySelector('[data-lds-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = !message;
  }

  function addToCart(root, button) {
    var installVariant = button.dataset.installVariant || root.dataset.installVariant;
    var installed = root.classList.contains('is-inst') && button.dataset.installable === 'true' && installVariant;

    var items = [{ id: Number(button.dataset.variant), quantity: 1 }];
    if (installed) {
      // Parts the install cannot proceed without go in with it, so the price
      // on the card and the price in the cart always agree.
      (button.dataset.required || '')
        .split(',')
        .filter(Boolean)
        .forEach(function (id) {
          items.push({
            id: Number(id),
            quantity: 1,
            properties: { 'Required for': button.dataset.title }
          });
        });
      items.push({
        id: Number(installVariant),
        quantity: 1,
        properties: { 'Installation for': button.dataset.title }
      });
    }

    showError(root, '');
    button.setAttribute('aria-busy', 'true');

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'That item could not be added.');
          return data;
        });
      })
      .then(function () {
        var after = root.dataset.afterAdd;
        if (after === 'checkout') {
          window.location.href = '/checkout';
        } else if (after === 'stay') {
          button.removeAttribute('aria-busy');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var original = button.getAttribute('data-original-label') || button.innerHTML;
          button.setAttribute('data-original-label', original);
          button.textContent = 'Added to cart';
          setTimeout(function () { button.innerHTML = original; }, 2200);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        button.removeAttribute('aria-busy');
        showError(root, err.message || 'Something went wrong. Try again, or call us at 1-866-824-4118.');
      });
  }

  // Filter state is a comma-separated list of handles, or the word 'all'.
  // A vendor handle can never contain a comma, so no escaping is needed.
  function readSet(root, key) {
    var raw = root.dataset[key] || 'all';
    if (raw === 'all' || raw === '') return [];
    return raw.split(',').filter(Boolean);
  }

  function writeSet(root, key, list) {
    root.dataset[key] = list.length ? list.join(',') : 'all';
  }

  function cardPassesBrand(card, brands) {
    return !brands.length || brands.indexOf(card.dataset.vendor) !== -1;
  }

  function cardPassesMeta(card, metas) {
    if (!metas.length) return true;
    var haystack = card.dataset.meta || '';
    for (var i = 0; i < metas.length; i++) {
      if (haystack.indexOf('|' + metas[i] + '|') !== -1) return true;
    }
    return false;
  }

  function applyFilters(root) {
    var brands = readSet(root, 'filterBrand');
    var metas = readSet(root, 'filterMeta');

    root.querySelectorAll('.lds-card').forEach(function (card) {
      card.hidden = !(cardPassesBrand(card, brands) && cardPassesMeta(card, metas));
    });

    // 'All' is pressed only when nothing in that facet is chosen.
    root.querySelectorAll('[data-lds-brand]').forEach(function (btn) {
      var v = btn.dataset.ldsBrand;
      var on = v === 'all' ? brands.length === 0 : brands.indexOf(v) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-lds-meta]').forEach(function (btn) {
      var v = btn.dataset.ldsMeta;
      var on = v === 'all' ? metas.length === 0 : metas.indexOf(v) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    // Counts are measured against the OTHER facet only, so a number always
    // means "this is what you'd get if you picked me" rather than counting
    // the option's own selection against itself.
    var cards = Array.prototype.slice.call(root.querySelectorAll('.lds-card'));

    root.querySelectorAll('[data-lds-brand]').forEach(function (btn) {
      var slot = btn.querySelector('[data-lds-brand-count]');
      if (!slot) return;
      var v = btn.dataset.ldsBrand;
      var n = cards.filter(function (c) {
        return (v === 'all' || c.dataset.vendor === v) && cardPassesMeta(c, metas);
      }).length;
      slot.textContent = '(' + n + ')';
    });

    root.querySelectorAll('[data-lds-meta]').forEach(function (btn) {
      var slot = btn.querySelector('[data-lds-meta-count]');
      if (!slot) return;
      var v = btn.dataset.ldsMeta;
      var n = cards.filter(function (c) {
        return (v === 'all' || (c.dataset.meta || '').indexOf('|' + v + '|') !== -1) &&
               cardPassesBrand(c, brands);
      }).length;
      slot.textContent = '(' + n + ')';
    });
  }

  function toggleFilter(root, key, value) {
    if (value === 'all') {
      writeSet(root, key, []);
      return;
    }
    if (root.dataset.multi !== 'true') {
      // Single-select: picking the active one again clears the facet.
      var current = readSet(root, key);
      writeSet(root, key, current.length === 1 && current[0] === value ? [] : [value]);
      return;
    }
    var list = readSet(root, key);
    var at = list.indexOf(value);
    if (at === -1) { list.push(value); } else { list.splice(at, 1); }
    writeSet(root, key, list);
  }

  function currentMode(root) {
    return root.classList.contains('is-inst') ? 'inst' : 'ship';
  }

  function applySort(root) {
    var wrap = root.querySelector('.lds-grid__items');
    if (!wrap) return;

    var how = root.dataset.sort || 'featured';
    var mode = currentMode(root);
    var cards = Array.prototype.slice.call(wrap.querySelectorAll('.lds-card'));

    cards.sort(function (a, b) {
      var ai = Number(a.dataset.idx || 0);
      var bi = Number(b.dataset.idx || 0);
      if (how === 'featured') return ai - bi;

      // Sort on whichever price the customer can currently see.
      var pa = Number((mode === 'inst' ? a.dataset.inst : a.dataset.ship) || 0);
      var pb = Number((mode === 'inst' ? b.dataset.inst : b.dataset.ship) || 0);
      if (pa === pb) return ai - bi;
      return how === 'price-desc' ? pb - pa : pa - pb;
    });

    cards.forEach(function (card) { wrap.appendChild(card); });

    var sel = root.querySelector('[data-lds-sort]');
    if (sel && sel.value !== how) sel.value = how;
  }

  function readUrlState(root) {
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return null; }
    if (q.get('brand')) root.dataset.filterBrand = q.get('brand');
    if (q.get('res')) root.dataset.filterMeta = q.get('res');
    if (q.get('sort')) root.dataset.sort = q.get('sort');
    return q.get('mode');
  }

  function writeUrlState(root) {
    if (root.dataset.urlState !== 'true') return;
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return; }

    var brand = root.dataset.filterBrand || 'all';
    var meta = root.dataset.filterMeta || 'all';
    var sort = root.dataset.sort || 'featured';

    // Defaults stay out of the URL, so an untouched page keeps a clean address.
    if (brand === 'all') { q.delete('brand'); } else { q.set('brand', brand); }
    if (meta === 'all') { q.delete('res'); } else { q.set('res', meta); }
    if (sort === 'featured') { q.delete('sort'); } else { q.set('sort', sort); }
    q.set('mode', currentMode(root));

    var qs = q.toString();
    try {
      window.history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
    } catch (e) { /* older browsers */ }
  }

  function copyShare(root) {
    writeUrlState(root);
    var done = root.querySelector('[data-lds-copied]');
    function flash() {
      if (!done) return;
      done.hidden = false;
      setTimeout(function () { done.hidden = true; }, 2000);
    }
    var url = window.location.href;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(flash, flash);
    } else {
      var t = document.createElement('textarea');
      t.value = url;
      t.setAttribute('readonly', '');
      t.style.position = 'absolute';
      t.style.left = '-9999px';
      document.body.appendChild(t);
      t.select();
      try { document.execCommand('copy'); } catch (e) { /* no-op */ }
      document.body.removeChild(t);
      flash();
    }
  }

  function levelNotes(root) {
    var boxes = Array.prototype.slice.call(root.querySelectorAll('[data-lds-vnotes]'));
    if (!boxes.length) return;
    boxes.forEach(function (b) { b.style.minHeight = ''; });
    var visible = boxes.filter(function (b) {
      var card = b.closest('.lds-card');
      return card && card.offsetParent !== null;
    });
    if (visible.length < 2) return;
    var tallest = 0;
    visible.forEach(function (b) {
      if (b.offsetHeight > tallest) tallest = b.offsetHeight;
    });
    visible.forEach(function (b) { b.style.minHeight = tallest + 'px'; });
  }

  function init(root) {
    if (root.dataset.ldsReady === 'true') return;
    root.dataset.ldsReady = 'true';

    // A shared link decides the view before anything else does.
    var urlMode = root.dataset.urlState === 'true' ? readUrlState(root) : null;

    applyFilters(root);
    applySort(root);
    levelNotes(root);

    var reLevel = function () { levelNotes(root); };
    if (document.readyState !== 'complete') window.addEventListener('load', reLevel);
    window.addEventListener('resize', function () {
      clearTimeout(root._ldsLevelTimer);
      root._ldsLevelTimer = setTimeout(reLevel, 150);
    });

    var startMode = root.classList.contains('is-inst') ? 'inst' : 'ship';
    if (root.dataset.remember === 'true' && root.dataset.installVariant) {
      var stored = readStored();
      if (stored === 'inst' || stored === 'ship') startMode = stored;
    }
    // A link that specifies a view wins over what this visitor last chose,
    // otherwise you cannot reliably send someone an installed-price view.
    if ((urlMode === 'inst' || urlMode === 'ship') && root.dataset.installVariant) {
      startMode = urlMode;
    }
    setMode(root, startMode, false);
    applySort(root);

    root.addEventListener('change', function (event) {
      var sel = event.target.closest('[data-lds-sort]');
      if (!sel) return;
      root.dataset.sort = sel.value;
      applySort(root);
      levelNotes(root);
      writeUrlState(root);
    });

    root.addEventListener('click', function (event) {
      var share = event.target.closest('[data-lds-share]');
      if (share) {
        copyShare(root);
        return;
      }
      var toggle = event.target.closest('[data-lds-mode]');
      if (toggle) {
        setMode(root, toggle.dataset.ldsMode, true);
        // Installed order is not shipped order, so re-sort on every switch.
        applySort(root);
        levelNotes(root);
        writeUrlState(root);
        return;
      }
      var brand = event.target.closest('[data-lds-brand]');
      if (brand) {
        toggleFilter(root, 'filterBrand', brand.dataset.ldsBrand);
        applyFilters(root);
        applySort(root);
        levelNotes(root);
        writeUrlState(root);
        return;
      }
      var meta = event.target.closest('[data-lds-meta]');
      if (meta) {
        toggleFilter(root, 'filterMeta', meta.dataset.ldsMeta);
        applyFilters(root);
        applySort(root);
        levelNotes(root);
        writeUrlState(root);
        return;
      }
      var addBtn = event.target.closest('[data-lds-add]');
      if (addBtn && !addBtn.hasAttribute('aria-busy')) addToCart(root, addBtn);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lds-installer]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-install-toggle"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STORE_KEY = 'lds-install-mode';

  function readStored() {
    try { return window.localStorage.getItem(STORE_KEY); } catch (e) { return null; }
  }

  function writeStored(mode) {
    try { window.localStorage.setItem(STORE_KEY, mode); } catch (e) { /* private mode */ }
  }

  function setMode(root, mode, persist) {
    root.classList.toggle('is-inst', mode === 'inst');
    root.classList.toggle('is-ship', mode !== 'inst');
    root.querySelectorAll('.lds-switch__btn[data-lds-mode]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.dataset.ldsMode === mode ? 'true' : 'false');
    });
    if (persist && root.dataset.remember === 'true') writeStored(mode);
  }

  function showError(root, message) {
    var el = root.querySelector('[data-lds-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = !message;
  }

  function addToCart(root, button) {
    var installVariant = button.dataset.installVariant || root.dataset.installVariant;
    var installed = root.classList.contains('is-inst') && button.dataset.installable === 'true' && installVariant;

    var items = [{ id: Number(button.dataset.variant), quantity: 1 }];
    if (installed) {
      // Parts the install cannot proceed without go in with it, so the price
      // on the card and the price in the cart always agree.
      (button.dataset.required || '')
        .split(',')
        .filter(Boolean)
        .forEach(function (id) {
          items.push({
            id: Number(id),
            quantity: 1,
            properties: { 'Required for': button.dataset.title }
          });
        });
      items.push({
        id: Number(installVariant),
        quantity: 1,
        properties: { 'Installation for': button.dataset.title }
      });
    }

    showError(root, '');
    button.setAttribute('aria-busy', 'true');

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'That item could not be added.');
          return data;
        });
      })
      .then(function () {
        var after = root.dataset.afterAdd;
        if (after === 'checkout') {
          window.location.href = '/checkout';
        } else if (after === 'stay') {
          button.removeAttribute('aria-busy');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var original = button.getAttribute('data-original-label') || button.innerHTML;
          button.setAttribute('data-original-label', original);
          button.textContent = 'Added to cart';
          setTimeout(function () { button.innerHTML = original; }, 2200);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        button.removeAttribute('aria-busy');
        showError(root, err.message || 'Something went wrong. Try again, or call us at 1-866-824-4118.');
      });
  }

  // Filter state is a comma-separated list of handles, or the word 'all'.
  // A vendor handle can never contain a comma, so no escaping is needed.
  function readSet(root, key) {
    var raw = root.dataset[key] || 'all';
    if (raw === 'all' || raw === '') return [];
    return raw.split(',').filter(Boolean);
  }

  function writeSet(root, key, list) {
    root.dataset[key] = list.length ? list.join(',') : 'all';
  }

  function cardPassesBrand(card, brands) {
    return !brands.length || brands.indexOf(card.dataset.vendor) !== -1;
  }

  function cardPassesMeta(card, metas) {
    if (!metas.length) return true;
    var haystack = card.dataset.meta || '';
    for (var i = 0; i < metas.length; i++) {
      if (haystack.indexOf('|' + metas[i] + '|') !== -1) return true;
    }
    return false;
  }

  function cardPassesMeta2(card, metas) {
    if (!metas.length) return true;
    var haystack = card.dataset.meta2 || '';
    for (var i = 0; i < metas.length; i++) {
      if (haystack.indexOf('|' + metas[i] + '|') !== -1) return true;
    }
    return false;
  }

  function applyFilters(root) {
    var brands = readSet(root, 'filterBrand');
    var metas = readSet(root, 'filterMeta');
    var metas2 = readSet(root, 'filterMeta2');

    root.querySelectorAll('.lds-card').forEach(function (card) {
      card.hidden = !(cardPassesBrand(card, brands) && cardPassesMeta(card, metas) && cardPassesMeta2(card, metas2));
    });
    root.querySelectorAll('[data-lds-meta2]').forEach(function (btn) {
      var v = btn.dataset.ldsMeta2;
      var on = v === 'all' ? metas2.length === 0 : metas2.indexOf(v) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    // 'All' is pressed only when nothing in that facet is chosen.
    root.querySelectorAll('[data-lds-brand]').forEach(function (btn) {
      var v = btn.dataset.ldsBrand;
      var on = v === 'all' ? brands.length === 0 : brands.indexOf(v) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-lds-meta]').forEach(function (btn) {
      var v = btn.dataset.ldsMeta;
      var on = v === 'all' ? metas.length === 0 : metas.indexOf(v) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    // Counts are measured against the OTHER facet only, so a number always
    // means "this is what you'd get if you picked me" rather than counting
    // the option's own selection against itself.
    var cards = Array.prototype.slice.call(root.querySelectorAll('.lds-card'));

    root.querySelectorAll('[data-lds-brand]').forEach(function (btn) {
      var slot = btn.querySelector('[data-lds-brand-count]');
      if (!slot) return;
      var v = btn.dataset.ldsBrand;
      var n = cards.filter(function (c) {
        return (v === 'all' || c.dataset.vendor === v) && cardPassesMeta(c, metas) && cardPassesMeta2(c, metas2);
      }).length;
      slot.textContent = '(' + n + ')';
    });

    root.querySelectorAll('[data-lds-meta]').forEach(function (btn) {
      var slot = btn.querySelector('[data-lds-meta-count]');
      if (!slot) return;
      var v = btn.dataset.ldsMeta;
      var n = cards.filter(function (c) {
        return (v === 'all' || (c.dataset.meta || '').indexOf('|' + v + '|') !== -1) &&
               cardPassesBrand(c, brands) && cardPassesMeta2(c, metas2);
      }).length;
      slot.textContent = '(' + n + ')';
    });

    root.querySelectorAll('[data-lds-meta2]').forEach(function (btn) {
      var slot = btn.querySelector('[data-lds-meta2-count]');
      if (!slot) return;
      var v = btn.dataset.ldsMeta2;
      var n = cards.filter(function (c) {
        return (v === 'all' || (c.dataset.meta2 || '').indexOf('|' + v + '|') !== -1) &&
               cardPassesBrand(c, brands) && cardPassesMeta(c, metas);
      }).length;
      slot.textContent = '(' + n + ')';
    });
  }

  function toggleFilter(root, key, value) {
    if (value === 'all') {
      writeSet(root, key, []);
      return;
    }
    if (root.dataset.multi !== 'true') {
      // Single-select: picking the active one again clears the facet.
      var current = readSet(root, key);
      writeSet(root, key, current.length === 1 && current[0] === value ? [] : [value]);
      return;
    }
    var list = readSet(root, key);
    var at = list.indexOf(value);
    if (at === -1) { list.push(value); } else { list.splice(at, 1); }
    writeSet(root, key, list);
  }

  function currentMode(root) {
    return root.classList.contains('is-inst') ? 'inst' : 'ship';
  }

  function applySort(root) {
    var wrap = root.querySelector('.lds-grid__items');
    if (!wrap) return;

    var how = root.dataset.sort || 'featured';
    var mode = currentMode(root);
    var cards = Array.prototype.slice.call(wrap.querySelectorAll('.lds-card'));

    cards.sort(function (a, b) {
      var ai = Number(a.dataset.idx || 0);
      var bi = Number(b.dataset.idx || 0);
      if (how === 'featured') return ai - bi;

      // Sort on whichever price the customer can currently see.
      var pa = Number((mode === 'inst' ? a.dataset.inst : a.dataset.ship) || 0);
      var pb = Number((mode === 'inst' ? b.dataset.inst : b.dataset.ship) || 0);
      if (pa === pb) return ai - bi;
      return how === 'price-desc' ? pb - pa : pa - pb;
    });

    cards.forEach(function (card) { wrap.appendChild(card); });

    var sel = root.querySelector('[data-lds-sort]');
    if (sel && sel.value !== how) sel.value = how;
  }

  function readUrlState(root) {
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return null; }
    if (q.get('brand')) root.dataset.filterBrand = q.get('brand');
    if (q.get('res')) root.dataset.filterMeta = q.get('res');
    if (q.get('f2')) root.dataset.filterMeta2 = q.get('f2');
    if (q.get('sort')) root.dataset.sort = q.get('sort');
    return q.get('mode');
  }

  function writeUrlState(root) {
    if (root.dataset.urlState !== 'true') return;
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return; }

    var brand = root.dataset.filterBrand || 'all';
    var meta = root.dataset.filterMeta || 'all';
    var meta2 = root.dataset.filterMeta2 || 'all';
    var sort = root.dataset.sort || 'featured';

    // Defaults stay out of the URL, so an untouched page keeps a clean address.
    if (brand === 'all') { q.delete('brand'); } else { q.set('brand', brand); }
    if (meta === 'all') { q.delete('res'); } else { q.set('res', meta); }
    if (meta2 === 'all') { q.delete('f2'); } else { q.set('f2', meta2); }
    if (sort === 'featured') { q.delete('sort'); } else { q.set('sort', sort); }
    q.set('mode', currentMode(root));

    var qs = q.toString();
    try {
      window.history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
    } catch (e) { /* older browsers */ }
  }

  function copyShare(root) {
    writeUrlState(root);
    var done = root.querySelector('[data-lds-copied]');
    function flash() {
      if (!done) return;
      done.hidden = false;
      setTimeout(function () { done.hidden = true; }, 2000);
    }
    var url = window.location.href;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(flash, flash);
    } else {
      var t = document.createElement('textarea');
      t.value = url;
      t.setAttribute('readonly', '');
      t.style.position = 'absolute';
      t.style.left = '-9999px';
      document.body.appendChild(t);
      t.select();
      try { document.execCommand('copy'); } catch (e) { /* no-op */ }
      document.body.removeChild(t);
      flash();
    }
  }

  function levelNotes(root) {
    var boxes = Array.prototype.slice.call(root.querySelectorAll('[data-lds-vnotes]'));
    if (!boxes.length) return;
    boxes.forEach(function (b) { b.style.minHeight = ''; });
    var visible = boxes.filter(function (b) {
      var card = b.closest('.lds-card');
      return card && card.offsetParent !== null;
    });
    if (visible.length < 2) return;
    var tallest = 0;
    visible.forEach(function (b) {
      if (b.offsetHeight > tallest) tallest = b.offsetHeight;
    });
    visible.forEach(function (b) { b.style.minHeight = tallest + 'px'; });
  }

  function init(root) {
    if (root.dataset.ldsReady === 'true') return;
    root.dataset.ldsReady = 'true';

    // A shared link decides the view before anything else does.
    var urlMode = root.dataset.urlState === 'true' ? readUrlState(root) : null;

    applyFilters(root);
    applySort(root);
    levelNotes(root);

    var reLevel = function () { levelNotes(root); };
    if (document.readyState !== 'complete') window.addEventListener('load', reLevel);
    window.addEventListener('resize', function () {
      clearTimeout(root._ldsLevelTimer);
      root._ldsLevelTimer = setTimeout(reLevel, 150);
    });

    var startMode = root.classList.contains('is-inst') ? 'inst' : 'ship';
    if (root.dataset.remember === 'true' && root.dataset.installVariant) {
      var stored = readStored();
      if (stored === 'inst' || stored === 'ship') startMode = stored;
    }
    // A link that specifies a view wins over what this visitor last chose,
    // otherwise you cannot reliably send someone an installed-price view.
    if ((urlMode === 'inst' || urlMode === 'ship') && root.dataset.installVariant) {
      startMode = urlMode;
    }
    setMode(root, startMode, false);
    applySort(root);

    root.addEventListener('change', function (event) {
      var sel = event.target.closest('[data-lds-sort]');
      if (!sel) return;
      root.dataset.sort = sel.value;
      applySort(root);
      levelNotes(root);
      writeUrlState(root);
    });

    root.addEventListener('click', function (event) {
      var share = event.target.closest('[data-lds-share]');
      if (share) {
        copyShare(root);
        return;
      }
      var toggle = event.target.closest('[data-lds-mode]');
      if (toggle) {
        setMode(root, toggle.dataset.ldsMode, true);
        // Installed order is not shipped order, so re-sort on every switch.
        applySort(root);
        levelNotes(root);
        writeUrlState(root);
        return;
      }
      var brand = event.target.closest('[data-lds-brand]');
      if (brand) {
        toggleFilter(root, 'filterBrand', brand.dataset.ldsBrand);
        applyFilters(root);
        applySort(root);
        levelNotes(root);
        writeUrlState(root);
        return;
      }
      var meta2 = event.target.closest('[data-lds-meta2]');
      if (meta2) {
        toggleFilter(root, 'filterMeta2', meta2.dataset.ldsMeta2);
        applyFilters(root);
        applySort(root);
        levelNotes(root);
        writeUrlState(root);
        return;
      }
      var meta = event.target.closest('[data-lds-meta]');
      if (meta) {
        toggleFilter(root, 'filterMeta', meta.dataset.ldsMeta);
        applyFilters(root);
        applySort(root);
        levelNotes(root);
        writeUrlState(root);
        return;
      }
      var addBtn = event.target.closest('[data-lds-add]');
      if (addBtn && !addBtn.hasAttribute('aria-busy')) addToCart(root, addBtn);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lds-installer]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-announcement-slider"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class AnnouncementSliderSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;
    this.resizeTimeout = null;
    this.showArrows = this.data.show_arrows;
    this.observers = []; 
    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;

    this.$root.classList.remove('pxu-announcement-slider--initialized');

    const options = {
      prevNextButtons: true,
      pageDots: false,
      groupCells: false,
      cellAlign: 'left',
      wrapAround: true,
      autoPlay: this.data.auto_rotate ? this.data.rotation_speed * 1000 : false,
    };

    this.carousel = new Carousel(this.$root, options);
    this.carousel.onMount();

    setTimeout(() => {
      this.adjustNavigationButtons();
      this.toggleButtonVisibility(this.showArrows);
      this.$root.classList.add('pxu-announcement-slider--initialized'); 
    }, 0);
  
    this.initEventListeners();
  }

  waitForElement(selector, callback) {
    const element = this.$root.querySelector(selector);
    
    if (element) {
      callback(element);
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      const element = this.$root.querySelector(selector);
      if (element) {
        obs.disconnect();
        callback(element);
        this.observers = this.observers.filter(o => o !== obs); 
      }
    });

    observer.observe(this.$root, { childList: true, subtree: true });
    this.observers.push(observer); 
  }

  initEventListeners() {
    this.events.register(window, 'resize', () => {
      this.toggleButtonVisibility(false);
      clearTimeout(this.resizeTimeout);

      this.resizeTimeout = setTimeout(() => {
        this.adjustNavigationButtons();
        this.toggleButtonVisibility(this.showArrows);
      }, 200);
    });

    this.events.register(window, 'load', () => {
      this.adjustNavigationButtons();
      this.toggleButtonVisibility(this.showArrows);
    });

    this.events.register(document, 'keydown', (event) => {
      if (event.key === 'Tab') {
        this.toggleButtonVisibility(true);
      }
    });

    this.events.register(document, 'click', (event) => {
      if (this.showArrows === false && !event.target.closest('.flickity-prev-next-button')) {
        this.toggleButtonVisibility(false);
      }
    });

    this.toggleButtonVisibility(false);
  }

  toggleButtonVisibility(visible) {
    this.waitForElement('.flickity-prev-next-button', () => {
      const buttons = this.$root.querySelectorAll('.flickity-prev-next-button');
      buttons.forEach(button => {
        button.style.transition = visible ? 'opacity 0.2s ease-out' : 'none';
        button.style.opacity = visible ? '1' : '0';
        button.style.pointerEvents = visible ? 'auto' : 'none';
      });
    });
  }

  adjustNavigationButtons() {
    this.waitForElement('.flickity-prev-next-button', () => {
      const prevButton = this.$root.querySelector('.flickity-prev-next-button.previous');
      const nextButton = this.$root.querySelector('.flickity-prev-next-button.next');
      const announcements = this.$root.querySelectorAll('.pxu-announcement-slider__text');
      const viewport = window.innerWidth;
      const container = this.$root.querySelector('.pxu-section__container');

      if (!announcements.length || !container) return;

      let maxWidth = 0;
      announcements.forEach((el) => {
        const width = el.getBoundingClientRect().width;
        maxWidth = Math.max(maxWidth, width);
      });

      const containerRect = container.getBoundingClientRect();
      const minWidth = 650;
      let buttonOffset = 8;

      if (viewport >= 860) {
        const containerLeftEdge = containerRect.left;
        const containerRightEdge = viewport - containerRect.right;
        const announcementMaxWidth = maxWidth;
        const announcementLeftEdge = containerLeftEdge + (containerRect.width - announcementMaxWidth) / 2;
        const announcementRightEdge = containerRightEdge + (containerRect.width - announcementMaxWidth) / 2;

        if (maxWidth <= minWidth) {
          const leftGap = (announcementLeftEdge - containerLeftEdge) / 2;
          const rightGap = (containerRightEdge - announcementRightEdge) / 2;
          const maxOffset = Math.min(leftGap, rightGap);
          buttonOffset = maxOffset;
        }
      }

      prevButton.style.left = `${-buttonOffset}px`;
      nextButton.style.right = `${-buttonOffset}px`;
    });
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
    this.events.unregisterAll();
    this.observers.forEach(observer => observer.disconnect());
    this.observers = [];
  }

  onBlockSelect(event) {
    if (!this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-announcement-slider]').forEach(($section) => {
  Section.init($section, AnnouncementSliderSection);
});

if (Shopify.designMode) {
  window.PxuThemeSections.AnnouncementSliderSection = AnnouncementSliderSection;
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-highlights-banner"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;
class HighlightsBannerSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;
    this.carousel = new Carousel(this.$root, {
      draggable: true,
      cellAlign: 'left'
    });
    setTimeout(() => {
      this.carousel.onMount();
    }, 100);
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.data.hasSlider || !this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll(`[data-pxu-highlights-banner]`).forEach(($section) => {
  Section.init($section, HighlightsBannerSection);
});

// Export for theme editor instance management.
if (Shopify.designMode) {
  window.PxuThemeSections.HighlightsBannerSection = HighlightsBannerSection;
}

  } catch(e) { console.error(e); }
})();
})();
